import React from 'react';
import { IExamResultPageProps } from './ExamResultPage.types';
import { ExamResultContainer } from '../../containers/ExamResultContainer/ExamResultContainer';

const ExamResultPage: React.FC<IExamResultPageProps> = ({ match }: IExamResultPageProps) => {
  return <ExamResultContainer routeParams={match.params} />;
};

export default ExamResultPage;
